import { IPartialGradeMetricsQuery } from '../interfaces/partial-grade-metric.query.interface';

export class PartialGradeMetrics {
    average: number;
    lowest: number;
    highest: number;
    belowPassing: number;
    participantsCount: number;

    constructor(query: IPartialGradeMetricsQuery) {
        if (!query) {
            throw new Error(`Unable to create new PartialGradeMetric since no values were passed to the constructor: ${JSON.stringify(query)}`);
        }

        this.average = query.average;
        this.lowest = query.lowest;
        this.highest = query.highest;
        this.belowPassing = query.below_passing;
        this.participantsCount = query.participants_count;
    }
}
